var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import "../ui.css";
import { useDataUiTheme } from "../utility/getDataUiTheme";
import { formatter } from "../utility/formatter";
export var RadixTextArea = React.forwardRef(function (_a, ref) {
    var wrapperClassName = _a.wrapperClassName, className = _a.className, label = _a.label, id = _a.id, errorMessage = _a.errorMessage, props = __rest(_a, ["wrapperClassName", "className", "label", "id", "errorMessage"]);
    var uiTheme = useDataUiTheme();
    var fallbackId = React.useRef("radix-textarea-".concat(Math.random().toString(36).slice(2, 10)));
    var textareaId = id || fallbackId.current;
    var errorId = errorMessage ? "".concat(textareaId, "-error") : undefined;
    var ariaInvalid = props["aria-invalid"];
    var isInvalid = Boolean(errorMessage) || ariaInvalid === true || ariaInvalid === "true";
    return (React.createElement("div", { className: ["radix-textarea-wrapper", wrapperClassName].filter(Boolean).join(" "), "data-invalid": isInvalid ? "true" : undefined, "data-ui-theme": uiTheme },
        label ? React.createElement("label", { className: "radix-textarea-label", htmlFor: textareaId }, formatter.toSentenceCase(label)) : null,
        React.createElement("textarea", __assign({}, props, { ref: ref, id: textareaId, className: ["radix-textarea", className].filter(Boolean).join(" "), "aria-invalid": isInvalid ? "true" : props["aria-invalid"], "aria-describedby": errorId || props["aria-describedby"] })),
        errorMessage ? React.createElement("span", { id: errorId, className: "radix-error-message" }, errorMessage) : null));
});
RadixTextArea.displayName = "RadixTextArea";
